import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=d2df8bea&scoped=true&"
import script from "./goodList.vue?vue&type=script&lang=js&"
export * from "./goodList.vue?vue&type=script&lang=js&"
import style0 from "./goodList.vue?vue&type=style&index=0&id=d2df8bea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2df8bea",
  null
  
)

export default component.exports